import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { AggsContainer } from "./AggsContainer";

var assign = require("lodash/assign");

export function FieldMetricFactory(metricOp) {
  return function (key, field) {
    return AggsContainer(key, _defineProperty({}, metricOp, {
      field: field
    }));
  };
}
export var CardinalityMetric = FieldMetricFactory("cardinality");
export var MinMetric = FieldMetricFactory("min");
export var MaxMetric = FieldMetricFactory("max");
export var AvgMetric = FieldMetricFactory("avg");
export var SumMetric = FieldMetricFactory("sum");
export var StatsMetric = FieldMetricFactory("stats");
export function TopHitsMetric(key, top_hits) {
  return AggsContainer(key, {
    top_hits: top_hits
  });
}
export function GeoBoundsMetric(key, field) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return AggsContainer(key, {
    geo_bounds: assign({
      field: field
    }, options)
  });
}